// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper__dLW8-","empty":"Checkbox_empty__uKQGm","icon":"Checkbox_icon__mUl0U","label":"Checkbox_label__Kxo1-","disabled":"Checkbox_disabled__0iCAv"};